var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('vx-card',{attrs:{"title":"Cuenta STP PF"}},[_c('stp-account-pf-form',{attrs:{"personal-profile-id":parseInt(_vm.$route.params.id)}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }